import { Module } from 'vuex';
import { HistoryState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { HISTORY_ACTIONS } from './history.actions';
import { HISTORY_GETTERS } from './history.getters';
import { HISTORY_MUTATIONS } from './history.mutations';
import { getInitialHistoryState } from './history.state';

export const HISTORY_MODULE: Module<HistoryState, RootStoreState> = {
  namespaced: true,
  actions: HISTORY_ACTIONS,
  mutations: HISTORY_MUTATIONS,
  getters: HISTORY_GETTERS,
  state: getInitialHistoryState()
};
